// Only what en-AU says differently; every other string is en-US (mergeLocaleResources).
export const profile = {
  accountScope: {
    workspaceHint: "Organisation, team, and administration",
  },
  overview: {
    tileOrganizationTitle: "Organisation",
  },
} as const;
